import { render } from "./TermsModal.vue?vue&type=template&id=7118def4"
const script = {}

import "./TermsModal.vue?vue&type=style&index=0&id=7118def4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__